module.exports = __webpack_public_path__ + "static/media/mc-bigmac.4349e2c0.png";